<div mat-dialog-content>
  <div class="mat-dialog-content">
    @if (isLoading) {
      <app-loading-list></app-loading-list>
    }
    <div class="head-modal">
      <div class="img-head">
        <img src="assets/images/exclamation-circle.png" />
      </div>
      <div class="title-modal">
        <h1>Suspender medicamento?</h1>
      </div>
    </div>
    <p style="text-align-last: center;">
      Ao confirmar a suspensão, o item prescrito será removido da dispensação da farmácia e da checagem.
      Esta ação é irreversível!
    </p>
    @if (!isLoading) {
      <div class="body-modal">
        <div class="prescription-details">
          @if (!isMedicatedSolution && medicalPrescriptionToSuspend) {
            <span>
              <span>{{medicalPrescriptionToSuspend.medicineName}}</span>
            </span>
          }
          @if (isMedicatedSolution && medicatedSolutionPrescriptionToSuspend) {
            <span>
              @for (medicine of medicatedSolutionPrescriptionToSuspend.listSolutionMedicine; track medicine) {
                <div>
                  <span class="primary">{{medicine.medicineName}}</span>
                </div>
              }
            </span>
          }
        </div>
        <form class="form" [formGroup]="model">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Motivo</mat-label>
              <textarea matInput formControlName="motiveSuspended"></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
    }
  </div>
</div>
<div mat-dialog-footer class="footer-modal">
  <div class="row">
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="cancel()">
        @if (isLoading == false) {
          <span>Cancelar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="submit()">
        @if (isLoading == false) {
          <span>Suspender</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>